<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Auditeurs" />
        <LesAuditeurs/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import LesAuditeurs from './LesAuditeurs.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        LesAuditeurs,
        FooterComp,
    }
}
</script>